import i18n from '@/lang';
const $t = (args) => i18n.t(args);

export default {
  data: {
    userUpload: [
      [`${$t('为了准确快速导入数据，请阅读以下要求：')}
        ${$t('1、编辑下方信息时，禁止修改或增加新的字段信息，否则会导致导入失败；')}
        ${$t('2、用户账号，用户名称，员工编号，所属组织为必填项，请务必正确填写；')}
        ${$t('3、请勿输入重复数据；')}
        ${$t('4、如导入账号为已有数据，则视为更新已有数据；')}
        ${$t('5、所属组织请填写组织编码；')}`],
      [$t('用户账号'), $t('用户名称'), $t('员工编号'), $t('所属组织编码'), $t('电话'), $t('邮件地址'), $t('简介')]
    ],
    dictionary: [
      [`${$t('为了准确快速导入数据，请阅读以下要求：')}
        ${$t('1、编辑下方信息时，禁止修改或增加新的字段信息，否则会导致导入失败；')}
        ${$t('2、字典编码，字典名称，数据项编码，数据项名称，数据项状态为必填项，请务必正确填写；')}
        ${$t('3、请勿输入重复数据；')}
        ${$t('4、如导入字典编码为已有数据，则视为更新已有数据；')}
        ${$t('5、导入时，同一字典下相同字典编码必须要对应相同的字典名称，字典分组编码，字典描述')}`],
      [$t('字典编码'), $t('字典名称'), $t('字典分组编码'), $t('字典描述'), $t('数据项编码'), $t('数据项名称'), $t('数据项状态'), $t('数据项描述')]
    ],
    organization: [
      [`${$t('为了准确快速导入数据，请阅读以下要求：')}
        ${$t('1、编辑下方信息时，禁止修改或增加新的字段信息，否则会导致导入失败；')}
        ${$t('2、组织编码，组织名称，组织类型为必填项，请务必正确填写；')}
        ${$t('3、请勿输入重复数据；')}
        ${$t('4、如导入组织编码为已有数据，则视为更新已有数据')}`],
      [$t('组织编码'), $t('组织名称'), $t('组织简称'), $t('组织类型'), $t('组织状态'), $t('上级组织编码'), $t('组织描述'), $t('排序')]
    ],
    registered: [
      ['SN', 'hardwareId', 'agentName']
    ],
    alarmCode: [
      [`${$t('说明：告警级别只能单选，影响类别字段可多选，多选时请用英文逗号分隔。\n')}${$t('1.告警级别：\nCOMMON：普通；\nIMPORTANT：重要；\nSERIOUS：严重\n')}${$t('2.影响类别：\nNOT_COUNTED：不统计；\nPRODUCTIVITY：生产效率；\nHEALTH：设备健康；\nQUALITY：工艺质量；\nOPERATE：操作规范')}`],
      [$t('告警码'), $t('告警标识符'), $t('级别'), $t('影响类别'), $t('告警内容\(简中\)'), $t('告警内容\(繁中\)'), $t('告警内容\(英文\)')]
    ]
  },
  style: {
    alarmCode: {
      '!cols': [{ wch: 35 }, { wch: 15 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }],
      s: [{
        cell: 'A1',
        style: {
          font: {
            color: { rgb: 'f45656' }
          },
          alignment: { vertical: 'center', wrapText: true }
        }
      }]
    }
  }
};
